// --------------------------------------------------------------------------
// Fichero: config.js
// Responsable: Josue Bellota Ichaso
//
// Descripción:
// Este fichero contiene la configuración de la aplicación.
// --------------------------------------------------------------------------

// URL base del Servidor REST
export const API_BASE = "https://us-central1-proyectodebiometria.cloudfunctions.net/ServidorREST";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDYvrCfTAJn0irG23qF3gTDCTMT9TGZQNk",
  authDomain: "proyectodebiometria.firebaseapp.com",
  projectId: "proyectodebiometria",
  storageBucket: "proyectodebiometria.firebasestorage.app",
  messagingSenderId: "174840664338",
  appId: "1:174840664338:web:8cd5fec4b879df480423cb"
};
